export const NAVBAR_ITEMS_KEYS = {
  MAIN_MENU: "mainMenu",
  DASHBOARD: "dashboard",
  USER_MANAGEMENT: "user-management",
  BOOKINGS_MANAGEMENT: "bookings-management",
  WITHDRAWAL_MANAGEMENT: "withdrawal-management",
  DISPUTES_MANAGEMENT: "disputes-management",
  REVIEWS_MANAGEMENT: "reviews-management",
  VERIFICATION_MANAGEMENT: "verification-management",
  PRODUCT_REQUESTS: "product-requests",
  PROFILE: "profile",
};

export const NAVBAR_ITEMS_VALUES = {
  dashboard: "Dashboard",
  "user-management": "User Management",
  "customer-management": "Customer Management",
  "bookings-management": "Bookings Management",
  "withdrawal-management": "Withdrawal",
  "disputes-management": "Disputes Management",
  "reviews-management": "Reviews Management",
  "verification-management": "User Verifications",
  "product-requests": "Product Requests",
  profile: "Profile",
};
